export default function ($stateProvider) {
	"ngInject";
    $stateProvider.state('survey', {
        url: '/s/:surveyKey?lang&i',
        template: `<survey class="stack"></survey>`,
        resolve: {
            init: function($stateParams, surveyService) {
                if (!surveyService.getSurvey().title) {
                    return surveyService.init($stateParams.surveyKey, $stateParams.i, $stateParams.lang);
                } else {
                    return Promise.resolve();
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./app/components/survey/survey.config.js